import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-449d680d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "com-div clearfix pos-rel"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "clearfix links fr"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconarrow-01"
}, null, -1));

const _hoisted_6 = {
  class: "dropdown dropdown-box"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popper-arrow"
}, null, -1));

const _hoisted_8 = {
  key: 1,
  href: "javascript:;",
  class: "dorp"
};
const _hoisted_9 = {
  class: "loginAfter"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "lgSpan"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconzzhedie lgI"
}, null, -1));

const _hoisted_13 = {
  class: "dorp_con"
};
const _hoisted_14 = {
  class: "zhong-ying"
};
const _hoisted_15 = ["href"];

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin": "0 10px"
  }
}, "|", -1));

const _hoisted_17 = ["href"];
const _hoisted_18 = {
  href: "/#dl",
  class: "download download-head colorFFF"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiazai- ml"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toPage('/')),
    class: "fl"
  }, [_createElementVNode("img", {
    class: "logo",
    src: require('@/assets/img/logo-goby.svg')
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
    class: _normalizeClass(["link mr00", {
      active: _ctx.routeName == 'features'
    }]),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.toPage('/features'))
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Features")), 1)], 2), _createElementVNode("a", {
    class: _normalizeClass(["link mr00", {
      active: _ctx.routeName == 'extensions'
    }]),
    onClick: _cache[2] || (_cache[2] = $event => _ctx.toPage('/extensions'))
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Extensions")), 1)], 2), _createElementVNode("a", {
    class: _normalizeClass(["link mr00", {
      active: _ctx.routeName == 'updates'
    }]),
    onClick: _cache[3] || (_cache[3] = $event => _ctx.toPage('/updates'))
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Updates")), 1)], 2), _createElementVNode("a", {
    class: _normalizeClass(["link mr00", {
      active: _ctx.routeName == 'sale'
    }]),
    onClick: _cache[4] || (_cache[4] = $event => _ctx.toPage('/sale'))
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Pricing")), 1)], 2), _createElementVNode("a", {
    class: "link mr00 doc-link",
    onClick: _cache[9] || (_cache[9] = //@ts-ignore
    (...args) => _ctx.toggleDocDropdown && _ctx.toggleDocDropdown(...args))
  }, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(_ctx.$t("Docs.Docs")), 1), _hoisted_5]), _withDirectives(_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.toPage('/faq'))
  }, _toDisplayString(_ctx.$t("FAQ")), 1)]), _createElementVNode("div", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[6] || (_cache[6] = $event => _ctx.toPage('/doc'))
  }, _toDisplayString(_ctx.$t("Docs.Extensions")), 1)]), _createElementVNode("div", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[7] || (_cache[7] = $event => _ctx.toPage('/exp'))
  }, _toDisplayString(_ctx.$t("Docs.Exp")), 1)]), _createElementVNode("div", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[8] || (_cache[8] = $event => _ctx.toPage('/goExp'))
  }, _toDisplayString(_ctx.$t("Docs.GoExp")), 1)])], 512), [[_vShow, _ctx.showDocDropdown]])]), !_ctx.userInfo.username ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "signClass",
    onClick: _cache[10] || (_cache[10] = $event => _ctx.toPage('/signIn'))
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Sign in")), 1)])) : _createCommentVNode("", true), _ctx.userInfo.username ? (_openBlock(), _createElementBlock("a", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: require('@/assets/img/Avatar.svg')
  }, null, 8, _hoisted_10), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userInfo.username), 1), _hoisted_12]), _createElementVNode("ul", _hoisted_13, [_createElementVNode("li", {
    class: "headerUrLi",
    onClick: _cache[11] || (_cache[11] = $event => _ctx.toPage('/center'))
  }, _toDisplayString(_ctx.$t("Your profile")), 1), _createElementVNode("li", {
    class: "headerUrLi",
    onClick: _cache[12] || (_cache[12] = $event => _ctx.toPage('/center/licenseManagement'))
  }, _toDisplayString(_ctx.$t("License")), 1), _createElementVNode("li", {
    class: "headerUrLi",
    onClick: _cache[13] || (_cache[13] = $event => _ctx.toPage('/center/orderManagement'))
  }, _toDisplayString(_ctx.$t("Order")), 1), _createElementVNode("li", {
    class: "headerSignOut",
    onClick: _cache[14] || (_cache[14] = //@ts-ignore
    (...args) => _ctx.signOut && _ctx.signOut(...args))
  }, _toDisplayString(_ctx.$t("Sign out")), 1)])])) : _createCommentVNode("", true), _createElementVNode("a", _hoisted_14, [_createElementVNode("a", {
    class: _normalizeClass(['lang-text', _ctx.lang == 'zh' ? 'active' : '']),
    href: _ctx.getUrl('zh')
  }, "中", 10, _hoisted_15), _hoisted_16, _createElementVNode("a", {
    class: _normalizeClass(['lang-text', _ctx.lang == 'en' ? 'active' : '']),
    href: _ctx.getUrl('en')
  }, " EN", 10, _hoisted_17)]), _createElementVNode("a", _hoisted_18, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("Download")), 1), _hoisted_19])])])])]);
}